import { render, staticRenderFns } from "./SolicitudesPantalla.vue?vue&type=template&id=1145185e&"
import script from "./SolicitudesPantalla.vue?vue&type=script&lang=ts&"
export * from "./SolicitudesPantalla.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports